/**
 * Locale readiness for attraction content.
 * empty — no package yet
 * generated — AI wrote it, not human-reviewed
 * reviewed — moderator accepted this language
 */
export enum AttractionLocaleStatusEnum {
    EMPTY = 'empty',
    GENERATED = 'generated',
    REVIEWED = 'reviewed',
}
